module.exports = __webpack_public_path__ + "img/point.bbbaef3e.png";